
import React, { Component } from 'react';
import Moment from 'moment';
import axios from "axios";
const idToken = JSON.parse(localStorage.getItem('okta-token-storage'));

class Addnewdocs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ...this.props,
            file1: null,
            filename: '',
            loading: false,
            fid: parseInt(Moment(new Date()).format("hh") + Moment(new Date()).format("mm") + Moment(new Date()).format("ss")),
            modifiedby: idToken.idToken.claims.name,
            date_updated: Moment(new Date()).format("yyyy-MM-DDTHH:mm:ss"),

        }
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        //this.onChangeImageHandler = this.onChangeImageHandler.bind(this)
        this.onChangeImageHandler1 = this.onChangeImageHandler1.bind(this)

    }



    onChange = e => this.setState({ [e.target.name]: e.target.value });

    onChangeImageHandler1 = e => {
        this.setState({ file1: e.target.files[0] });
        this.state.responseData.files[this.state.d].filename = e.target.value.replace("C:\\fakepath\\", "");
        {
            (this.state.d).length ?
                this.state.responseData.files[this.state.d].updated = this.state.date_updated
                :
                (this.state.responseData.files).push({ "updated": this.state.updated })
        };
        {
            (this.state.d).length ?
                this.state.responseData.files[this.state.d].Modifiedby = this.state.modifiedby
                :

                (this.state.responseData.files).push({ "Modifiedby": this.state.modified })
        };
        this.state.responseData.id = this.state.id
        this.state.responseData.index=process.env.REACT_APP_NAME;

    };

    onSubmit = (e) => {
        // e.preventDefault();
        // e.stopPropagation();
        this.setState({ loading: true });

        //axios.post('https://fs3.acl.gov/UpdateNADRCFile', this.state.responseData);
       // axios.post('http://localhost:3001/UpdateNADRCFile', this.state.responseData);
       axios.post('https://fs3.acl.gov/updateFile', this.state.responseData);
        const formData = new FormData();
        formData.append('file1', this.state.file1);
// production
          fetch(process.env.REACT_APP_LOGIC_APP_URL, {
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data , boundary=?"

            },
            body: formData
        }) 


    };

    render() {

        const { loading } = this.state;

        return (

            <div>
                <div class="row body_content">

                    <div class="row" style={{ width: 100 + "%" }}>
                        <div class="post-content" style={{ width: 90 + "%" }}>


                            <form onSubmit={e => {

                                this.onSubmit()
                                e.preventDefault()
                                setTimeout(function () {
                                    e.preventDefault();
                                    window.location.reload();
                                }, 3000)

                            }}

                            >

                                <div grid grid-cols-6 gap-6>
                                    <div class="flex flex-wrap -mx-3 mb-6">
                                        <div class="w-full px-3">
                                            <label
                                                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                                for="grid-first-name"
                                            >
                                                Resource Title
                                              </label>
                                            <input
                                                class="appearance-none block w-full bg-gray-200 text-gray-700 border  border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                type="text"
                                                name="title"
                                                id="title"
                                                //onChange={this.onChange}
                                                aria-describedby="title"
                                                placeholder="Enter Title"
                                                value={this.state.title}
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group col-span-4 block text-sm font-semibold text-gray-700 mt-8">

                                        <input type="file" accept=".doc,.docx,.pdf, .xlsx, .xls, .csv, .pptx" class="form-control-file" id="file1" name="file1"

                                            //onChange={e => setState({ ...this.state.responseData.files[this.state.d], filename: e.target.value })}
                                            onChange={this.onChangeImageHandler1}
                                        />
                                    </div>
                                    <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">                    
                                        <button
                                            disabled={loading}
                                            type="submit"
                                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        >
                                            {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />
                                            )}
                                            {loading && <span>Uploading</span>}
                                            {!loading && <span>Update</span>}

                                        </button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div >

            </div>

        );
    }
}



export default Addnewdocs;

